import { graphql } from "@/lib/gql/__generated__";

export const UpdateGoogleFreeBookingLinksSettingsI18n = graphql(`
	mutation GoogleFreeBookingLinksSettingsI18nUpdate($input: GoogleFreeBookingLinksSettingsI18nInput!) {
		googleFreeBookingLinksSettingsI18nUpdate(input: $input) {
			userErrors
			googleFreeBookingLinksSettingsI18n {
				id
				lang
				hotelID
				hotelName
				address {
					country
					addr1
					addr2
					addr3
					city
					province
					postalCode
				}
				createdAt
				updatedAt
			}
		}
	}
`);
